<template>
	<main class="section">
		<div class="container">
			<h1 class="title">Editando ficha de produto</h1>

			<ValidationObserver
				ref="form"
				v-slot="{ handleSubmit, pristine, invalid }"
			>
				<form @submit.prevent="handleSubmit(onSubmit)">
					<ProductFormFields v-model="formData" />
					<div class="buttons">
						<button
							type="submit"
							class="button is-primary"
							:class="{ 'is-loading': isSaving }"
							:disabled="pristine || invalid"
						>
							Salvar
						</button>
						<router-link exact to="/admin/products" class="button is-light"
							>Cancelar</router-link
						>
					</div>
				</form>
			</ValidationObserver>
		</div>
	</main>
</template>

<script>
import axios from 'axios';
import { ValidationObserver } from 'vee-validate';

import ProductFormFields from '@/components/Product/ProductFormFields';
import QuickToast from '@/utilities/quick-toast';

function isEmpty(obj) {
	for (var key in obj) {
		if (obj.hasOwnProperty(key)) return false;
	}
	return true;
}

export default {
	name: 'ProductEdit',

	components: {
		ProductFormFields,
		ValidationObserver,
	},

	data: () => ({
		isSaving: false,
		formData: {
			name: '',
			highlightText: '',
			characteristics: '',
			attractiveness: '',
			goldenTip: '',
			history: '',
			tags: [],
			thumbnail: '',
			codes: [],
			moreInformationUrl: '',
			crop: {},
		},
	}),

	beforeRouteEnter(to, from, next) {
		axios
			.get(`/api/products/${to.params.id}`)
			.then((resp) =>
				next((vm) => {
					vm.formData = resp.data;
					vm.$Progress.finish();
				})
			)
			.catch((err) => {
				if (err.response.status === 404) next('/404');
				else next('/error');
			});
	},

	methods: {
		onSubmit() {
			this.$refs.form.validate().then((success) => {
				if (!success) return;

				this.onSaveProduct();
				this.$refs.form.reset();
			});
		},

		onSaveProduct() {
			var id = this.$route.params.id;
			this.isSaving = true;

			axios
				.put(`/api/products/${id}`, this.formData)

				.then((resp) => {
					if (!isEmpty(this.formData.crop)) this.onSaveProductImage(id);
					else {
						this.isSaving = false;
						QuickToast.success('Alterações salvas!');
					}
				})

				.catch((_) => {
					this.isSaving = false;
					QuickToast.error(
						'Ocorreu um erro ao salvar a ficha de produto. Por favor, tente novamente mais tarde.'
					);
				});
		},

		onSaveProductImage(productID) {
			const formData = new FormData();
			for (let key in this.formData.crop)
				formData.append(key, this.formData.crop[key]);

			axios
				.put(`/api/products/${productID}/thumbnail`, formData, {
					headers: {
						'Content-Type': 'multipart/form-data',
					},
				})

				.then((_) => QuickToast.success('Alterações salvas!'))

				.catch((_) =>
					QuickToast.error(
						'Ocorreu um erro ao salvar a imagem do produto. Por favor, tente novamente mais tarde.'
					)
				)

				.finally((_) => (this.isSaving = false));
		},
	},
};
</script>

<style lang="scss" scoped>
.product-form {
	margin-bottom: 1.5rem;
}
</style>
